<script setup>
import { useI18n } from 'vue-i18n';

const emit = defineEmits(['change']);

const { t } = useI18n();

const modelValue = defineModel({
  type: Boolean,
  default: false,
});

const updateValue = () => {
  modelValue.value = !modelValue.value;
  emit('change', !modelValue.value);
};
</script>

<template>
  <button
    type="button"
    class="group relative h-6 rounded-full w-11 flex-shrink-0 select-none border border-transparent focus:outline-none focus:ring-2 focus:ring-n-brand/25 focus:ring-offset-2 focus:ring-offset-n-surface-1 dark:focus:ring-offset-n-slate-2 transition-all duration-200 ease-in-out"
    :class="
      modelValue
        ? 'bg-n-brand shadow-[0_10px_20px_rgba(4,120,87,0.18)] dark:shadow-[0_12px_22px_rgba(5,150,105,0.22)]'
        : 'bg-n-slate-7 dark:border dark:border-n-slate-7 dark:bg-n-slate-4'
    "
    role="switch"
    :aria-checked="modelValue"
    @click="updateValue"
  >
    <span class="sr-only">{{ t('SWITCH.TOGGLE') }}</span>
    <span
      class="absolute top-1/2 ltr:left-0.5 rtl:right-0.5 -translate-y-1/2 transition-transform duration-[350ms] ease-[cubic-bezier(0.34,1.56,0.64,1)]"
      :class="
        modelValue
          ? 'ltr:translate-x-5 rtl:-translate-x-5 group-active:ltr:translate-x-[18px] rtl:group-active:-translate-x-[18px]'
          : 'ltr:translate-x-0 rtl:translate-x-0'
      "
    >
      <span
        class="block h-[1.125rem] w-[1.125rem] rounded-full bg-n-surface-1 shadow-[0_4px_10px_rgba(15,23,42,0.18)] dark:bg-n-slate-12 dark:shadow-[0_6px_14px_rgba(0,0,0,0.28)] transition-[width] duration-[180ms] ease-in-out group-active:w-6"
      />
    </span>
  </button>
</template>
